<script>
	import FundingRateRangeSelectorItem from './FundingRateRangeSelectorItem.svelte';
</script>

<div class="flex text-fx-grey-200 text-xs xl:gap-5 gap-2 w-fit ml-auto items-center">
	<div class="text-fx-grey-300">Time Range:</div>
	<FundingRateRangeSelectorItem range="1D" />
	<FundingRateRangeSelectorItem range="1W" />
	<FundingRateRangeSelectorItem range="1M" />
</div>
